/**
 * ***************************
 * GlobalSubNav Routes in Archive Search *
 * ***************************
 */
import email from './email';
import vault from './vault';

const ArchiveSearchMain = () =>
  import('@/components/ArchiveSearch/ArchiveSearchMain');

export default {
  parent: 'Archive Search',
  path: '/archive-search',
  component: ArchiveSearchMain,
  redirect: '/archive-search/email/inbox/p1',
  meta: {
    type: 'archive',
    id: 'archive-search-tab'
  },

  children: [email, vault]
};
